import React from 'react'

import { IconButton } from '@material-ui/core';
import { Menu } from '@material-ui/icons';

import '../ToggleButton/toggle-button.css'


const ToggleButton = props => {


  return (
    <div >
      <IconButton className='toggle' onClick={() => props.setOpen(true)}>
        <Menu fontSize="large" className='icon' />
      </IconButton>
    </div>
  )
}

export default ToggleButton 